'use client';

import NextLink, { LinkProps as NextLinkProps } from 'next/link'

import { Link as ChakraLink } from '@chakra-ui/react'
import type { LinkProps as ChakraLinkProps } from '@chakra-ui/react'

type LinkProps = {
  children: React.ReactNode
  href: string
  newTab?: boolean
  _chakraLink?: ChakraLinkProps
} & NextLinkProps

const Link = ({ _chakraLink, newTab,  children, href, ...others }: LinkProps) => {
  const newTabProp = newTab ? { target: '_blank', rel: 'noopener noreferrer' } : {}

  return (
    <ChakraLink asChild {..._chakraLink}>
      <NextLink href={href} {...others} {...newTabProp}>
        {children}
      </NextLink>
    </ChakraLink>
  )
}

export default Link